import Vue from 'vue'
import '@mdi/font/css/materialdesignicons.css'
import { THEME_PORTAL, THEME_PORTAL_DARK } from '@/const'
import Vuetify from 'vuetify/lib'

// Vue.use(Vuetify)

const lc = window.localStorage

// export default new Vuetify({
//   icons: {
//     iconfont: 'mdi',
//   },
//   theme: {
//     dark: lc.getItem('DARKMODE') == 'true' ? true : false,
//     themes: {
//       light: THEME_PORTAL,
//       dark: THEME_PORTAL_DARK,
//     },
//   },
// })

// import Vue from 'vue'
// import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const opts = {
  icons: {
    iconfont: 'mdi',
  },
  theme: {
    dark: lc.getItem('DARKMODE') == 'true' ? true : false,
    themes: {
      light: THEME_PORTAL,
      dark: THEME_PORTAL_DARK,
    },
  },
}

export default new Vuetify(opts)
